import FetchTimeOut from "../FetchTimeOut/FetchTimeOut";

class FastApiAuth {
    #hostname = 'localhost';
    #port = '';
    #ssl = false;
    #url = '';
    #backendEndpoint = '';

    constructor(props) {
        this.props = props;
    }

    set backendEndpoint(endpoint) {
        this.#backendEndpoint = endpoint;
    }

    set hostname(hostname ='') {
        this.#hostname = hostname;
        this.setUrl();
    }

    set port(port = '') {
        this.#port = port;
        this.setUrl();
    }

    set ssl(ssl = false) {
        this.#ssl = ssl;
        this.setUrl();
    }

    setUrl() {
        this.#url = this.#ssl ? 'https://' : 'http://';
        this.#url += this.#hostname + this.#port;
    }

    setUsername(username) {
        this.username = username;
    }

    setPassword(password) {
        this.password = password;
    }

    loginTimeout() {
        if(this.#url === '') {
            console.error('FastApiAuth.login: url not provided');
            return;
        }
        this.api = new FetchTimeOut({
            url: this.#url + this.#backendEndpoint,
            timeout: this.props?.timeout,
            successCallback: this?.loginSuccessCallback,
            failureCallback: this?.loginFailureCallback,
            options: {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username: this.username,
                    password: this.password,
                }),
            }
        });
        this.api.pull()
    }
}

export default FastApiAuth;
